<template>
  <div>
    <SOSlotModal :modal-title="`Hapus Transaksi`" :modal-id="`modal${dataId}`" @close="back">
      <template v-slot:modal-body>
        <div>
          <div class="bg-yellow m-d-16">
            <div class="p-x-16 d-flex d-flex-align-center">
              <img src="../../../../assets/icons/alert-circle-yellow.svg" alt="" />
              <p class="m-d-0 p-l-8">
                Menghapus transaksi akan mengubah pencatatan pendapatan, hutang, atau piutang pada akun terkait di
                laporan keuangan Anda.
              </p>
            </div>
          </div>
          <div class="card_refund" v-if="showRefundList != -1 && refundList.length > 0">
            <SOCardRefund :data-list="refundList" />
          </div>
          <form class="modal-terima-transaksi">
            <div class="form-group">
              <div class="m-t-12">
                <SOInputRegular
                  :title="'Catatan (Opsional)'"
                  :placeholder="'Ketik catatan...'"
                  :validation="'alphanumeric'"
                  v-model="note"
                  @input="handleInput($event)"
                />
              </div>
            </div>
          </form>
        </div>
      </template>
      <template v-slot:modal-footer>
        <SOButton
          :outline-danger="true"
          :full="true"
          :text="'Hapus'"
          :id="dataId"
          :disable="isFetching"
          :loading="isFetching"
          @action="onApprove"
        />
      </template>
    </SOSlotModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOButton from "@/so-components/global/ui/SOButton";
import SOCardRefund from "../../reguler/components/SOCardRefund.vue";

import { moduleName } from "../store/state";

export default {
  name: "SOTerimaModal",
  components: {
    SOSlotModal,
    SOInputRegular,
    SOCardRefund,
    SOButton,
  },
  data() {
    return {
      note: "",
      isClick: false,
      listRefund: [],
      backLink: "PembatalanTransaksiSnapclean.list",
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.setBackLink(from.name);
      if (vm.dataDetail.data_refund === null) {
        vm.loadDetail();
      }
    });
  },
  mounted() {
    $(`#modal${this.dataId}`).modal("show");
  },
  watch: {
    response(newRes, oldRes) {
      if (this.isClick && newRes !== oldRes) {
        this.isClick = false;
        this.closeModal();
        if (newRes.success === true) {
          this.$router.push({
            name: "PembatalanTransaksiSnapclean.detail.data",
            params: { id: this.dataId },
          });
        } else {
          this.back();
        }
      }
    },
    dataDetail: function(newData, oldData) {
      if (newData.data_refund && newData.data_refund != oldData.data_refund) {
        this.listRefund = newData.data_refund;
      }
    },
  },
  computed: {
    ...mapGetters(moduleName, {
      response: "getResponse",
      isFetching: "isFecthing",
      dataDetail: "dataDetail",
    }),
    dataId() {
      return this.dataDetail.idhapus.toString();
    },
    refundList() {
      return this.listRefund;
    },
    showRefundList() {
      let showList = ["PembatalanTransaksiSnapclean.list"];

      return showList.indexOf(this.backLink);
    },
  },
  props: {
    useRoutePush: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapActions({
      getDetail: `${moduleName}/loadDetail`,
      updatePembatalan: `${moduleName}/updatePembatalan`,
    }),
    back() {
      this.closeModal();
      this.useRoutePush ? this.$router.push({ name: this.backLink }) : this.$emit("close");
    },
    async loadDetail() {
      await this.getDetail({ id: this.dataId });
    },
    closeModal() {
      $(`#modal${this.dataId}`).modal("hide");
    },
    setBackLink(routeBack) {
      this.backLink = routeBack;
    },
    handleInput(val) {
      this.note = val;
    },
    onApprove() {
      this.isClick = true;
      this.updatePembatalan({
        idpermintaanhapus: this.dataDetail.idhapus,
        idtransaksi: this.dataDetail.idtransaksi,
        keterangan_status: this.note,
        action: "approve",
      });
    },
  },
};
</script>
<style scoped>
.modal-terima-transaksi .form-group,
div.modal-footer button {
  margin-top: 0px;
  margin-bottom: 0px;
}
div.modal-dialog div div[class="modal-body"] {
  border-top: 1px solid #ededed;
}
.bg-yellow {
  margin-left: -16px;
  margin-right: -16px;
}
</style>
